import React from "react";
import enrollmentIcon from "../asset/enrollmentIcon.png";
import setupIcon from "../asset/setupIcon.png";
import learnIcon from "../asset/learnIcon.png";
import practiceIcon from "../asset/practiceIcon.png";
import certificationIcon from "../asset/certificationIcon.png";

const steps = [
  { icon: enrollmentIcon, label: "Enrollment" },
  { icon: setupIcon, label: "Orientation & Setup" },
  { icon: learnIcon, label: "Learn & Explore" },
  { icon: practiceIcon, label: "Practice & Projects" },
  { icon: certificationIcon, label: "Certification" },
];

const HowSkillara = () => {
  return (
    <section className="bg-gray-50 py-10 px-6 mb-2">
      {/* Heading */}
      <div className="text-center mb-6">
   <h2 className="text-4xl font-extrabold text-blue-900 dark:text-white">
          How Skillara ?
        </h2>
        <p className="text-gray-600 text-sm md:text-base max-w-2xl mx-auto">
          What makes us different from other online learning platforms
        </p>
      </div>

      {/* Timeline */}
      <div className="max-w-5xl mx-auto relative">
        {/* Center Vertical Line */}
        <div className="absolute left-1/2 top-10 h-[99%] w-[3px] bg-[#10316b] hidden md:block -translate-x-1/2" />

        <div className="flex flex-col gap-12 md:gap-16">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`relative z-10 flex w-full md:w-1/2
                ${index % 2 === 0 ? "md:self-end md:pl-8" : "md:self-start md:pr-8"}
              `}
            >
              {/* Horizontal connector line - Increased length & closer to icon */}
              <span
                className={`hidden md:block absolute top-1/2 -translate-y-1/2 h-[3px] bg-[#10316b]
                  ${index % 2 === 0 
                    ? "left-0 w-20"     // Longer line on even steps (right side)
                    : "right-0 w-20"    // Longer line on odd steps (left side)
                  }
                `}
              />

              <div className="flex flex-col items-center w-full">
                {/* Number Circle - Positioned directly at the timeline */}
                <div className="w-10 h-10 rounded-full bg-white border-4 border-[#10316b] flex items-center justify-center text-[#10316b] font-bold text-base mb-3 shadow-lg z-20">
                  {index + 1}
                </div>

                {/* Icon Circle */}
                <div className="w-28 h-28 rounded-full bg-[#10316b] flex items-center justify-center shadow-xl mb-3 -mt-2">
                  <img
                    src={step.icon}
                    alt={step.label}
                    className="w-[70%] h-[70%] object-contain"
                  />
                </div>

                {/* Label */}
                <p className="text-center text-[#10316b] font-semibold text-sm md:text-base leading-tight px-4 max-w-[200px]">
                  {step.label}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowSkillara;